 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","views-modules-info-info-module-ngfactory":"views-modules-info-info-module-ngfactory","views-modules-referral-referral-module-ngfactory":"views-modules-referral-referral-module-ngfactory","views-modules-vip-vip-module-ngfactory":"views-modules-vip-vip-module-ngfactory","default~views-modules-member-member-module-ngfactory~views-modules-mint-girl-mint-girl-module-ngfactory":"default~views-modules-member-member-module-ngfactory~views-modules-mint-girl-mint-girl-module-ngfactory","views-modules-member-member-module-ngfactory":"views-modules-member-member-module-ngfactory","views-modules-mint-girl-mint-girl-module-ngfactory":"views-modules-mint-girl-mint-girl-module-ngfactory","firebase-messaging":"firebase-messaging","views-modules-external-link-external-link-module-ngfactory":"views-modules-external-link-external-link-module-ngfactory","views-modules-lucky-spin-lucky-spin-module-ngfactory":"views-modules-lucky-spin-lucky-spin-module-ngfactory","views-modules-main-main-module-ngfactory":"views-modules-main-main-module-ngfactory","views-modules-promotion-promotion-module-ngfactory":"views-modules-promotion-promotion-module-ngfactory","default~games-games-module-ngfactory~pages-home-home-module-ngfactory":"default~games-games-module-ngfactory~pages-home-home-module-ngfactory","games-games-module-ngfactory":"games-games-module-ngfactory","default~pages-home-home-module-ngfactory~pages-landing-landing-module-ngfactory":"default~pages-home-home-module-ngfactory~pages-landing-landing-module-ngfactory","pages-home-home-module-ngfactory":"pages-home-home-module-ngfactory","pages-landing-landing-module-ngfactory":"pages-landing-landing-module-ngfactory","pages-login-login-module-ngfactory":"pages-login-login-module-ngfactory","pages-maintenance-maintenance-module-ngfactory":"pages-maintenance-maintenance-module-ngfactory","pages-processing-transaction-processing-transaction-module-ngfactory":"pages-processing-transaction-processing-transaction-module-ngfactory","pages-signup-signup-module-ngfactory":"pages-signup-signup-module-ngfactory","pages-verify-email-verify-email-module-ngfactory":"pages-verify-email-verify-email-module-ngfactory","pages-prediction-prediction-module-ngfactory":"pages-prediction-prediction-module-ngfactory","pages-crash-game-crash-game-module-ngfactory":"pages-crash-game-crash-game-module-ngfactory","pages-esports-esports-module-ngfactory":"pages-esports-esports-module-ngfactory","pages-fishing-fishing-module-ngfactory":"pages-fishing-fishing-module-ngfactory","pages-gamelaunch-gamelaunch-module-ngfactory":"pages-gamelaunch-gamelaunch-module-ngfactory","pages-launch-game-in-iframe-launch-game-in-iframe-module-ngfactory":"pages-launch-game-in-iframe-launch-game-in-iframe-module-ngfactory","pages-live-casino-game-live-casino-game-module-ngfactory":"pages-live-casino-game-live-casino-game-module-ngfactory","pages-live-casino-live-casino-module-ngfactory":"pages-live-casino-live-casino-module-ngfactory","pages-lottery-lottery-module-ngfactory":"pages-lottery-lottery-module-ngfactory","pages-slots-game-slots-game-module-ngfactory":"pages-slots-game-slots-game-module-ngfactory","pages-slots-game-slots-slots-module-ngfactory":"pages-slots-game-slots-slots-module-ngfactory","pages-sports-sports-module-ngfactory":"pages-sports-sports-module-ngfactory","pages-table-table-module-ngfactory":"pages-table-table-module-ngfactory"}[chunkId]||chunkId) + "-es2015." + {"common":"7c32b10a84e7f0e4b69f","views-modules-info-info-module-ngfactory":"b1e6e7674821c07f5dea","views-modules-referral-referral-module-ngfactory":"27d02c224d322b20ac85","views-modules-vip-vip-module-ngfactory":"5725e3fdebcae5433830","default~views-modules-member-member-module-ngfactory~views-modules-mint-girl-mint-girl-module-ngfactory":"08b93b04018c293ed1bf","views-modules-member-member-module-ngfactory":"89252ae99e7f4d0e96e2","views-modules-mint-girl-mint-girl-module-ngfactory":"9fa9960039284d515854","firebase-messaging":"21871492425f8e56e45f","views-modules-external-link-external-link-module-ngfactory":"0e61191070134f919ced","views-modules-lucky-spin-lucky-spin-module-ngfactory":"916dc8da61dc36635a1e","views-modules-main-main-module-ngfactory":"7e19d4d8074c72253b0f","views-modules-promotion-promotion-module-ngfactory":"5379c2459fbf60dcecdc","default~games-games-module-ngfactory~pages-home-home-module-ngfactory":"12b55f8f498df06a5013","games-games-module-ngfactory":"5f3a248fd238ac85a1bf","default~pages-home-home-module-ngfactory~pages-landing-landing-module-ngfactory":"bf97fbafe39d2b0e91ee","pages-home-home-module-ngfactory":"b6f5846a00f8f997a68c","pages-landing-landing-module-ngfactory":"6efe48db9a733f6efbcf","pages-login-login-module-ngfactory":"da582d983a66e02f3ff3","pages-maintenance-maintenance-module-ngfactory":"630176e32a9f236b2085","pages-processing-transaction-processing-transaction-module-ngfactory":"2d5049fb79307180038a","pages-signup-signup-module-ngfactory":"93850f7247ea0cd6a6ad","pages-verify-email-verify-email-module-ngfactory":"c4fb0ff6adc3467eb083","pages-prediction-prediction-module-ngfactory":"41961afb423062ea4e11","pages-crash-game-crash-game-module-ngfactory":"7b0f86cc5c2976b7e8a3","pages-esports-esports-module-ngfactory":"eb640ae3453412ca5dba","pages-fishing-fishing-module-ngfactory":"fea9ad632d8999c970ee","pages-gamelaunch-gamelaunch-module-ngfactory":"b54b8cbe2e9056784c3b","pages-launch-game-in-iframe-launch-game-in-iframe-module-ngfactory":"9638f6255396b3874852","pages-live-casino-game-live-casino-game-module-ngfactory":"2107bc9c4422d3f09df7","pages-live-casino-live-casino-module-ngfactory":"9a79d2e2addbf26feafa","pages-lottery-lottery-module-ngfactory":"f1860b22bbf69b20c3ed","pages-slots-game-slots-game-module-ngfactory":"326795f8d177afc91001","pages-slots-game-slots-slots-module-ngfactory":"bdd89e530910872cc961","pages-sports-sports-module-ngfactory":"45a10e53d3ca418b28c9","pages-table-table-module-ngfactory":"59e9d226dd3464515935"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
